// extracted by mini-css-extract-plugin
module.exports = {"header-extra-container":"_2xq6tnQlnokjYbZcrXAB","nth-place":"_3fE0RW3MdWrTVNrGskAB"};